import { Component, HostBinding, Input } from '@angular/core';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { IconColor } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, TextSize } from '@freelancer/ui/text';

export enum SectionArticleAlignment {
  LEFT = 'left',
  CENTER = 'center',
}

export enum SectionArticleColor {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum SectionArticleSize {
  MEDIUM = 'medium',
  LARGE = 'large',
}

@Component({
  selector: 'fl-section-article-heading',
  template: `
    <ng-content></ng-content>
  `,
})
export class SectionArticleHeadingComponent {}

@Component({
  selector: 'fl-section-article-description',
  template: `
    <ng-content></ng-content>
  `,
})
export class SectionArticleDescriptionComponent {}

@Component({
  selector: 'fl-section-article-entry',
  template: `
    <fl-icon
      *ngIf="icon"
      [color]="
        color === SectionArticleColor.DARK ? IconColor.DARK : IconColor.LIGHT
      "
      [name]="icon"
      [flMarginBottom]="Margin.SMALL"
    >
    </fl-icon>
    <fl-heading
      [color]="
        color === SectionArticleColor.DARK
          ? HeadingColor.DARK
          : HeadingColor.LIGHT
      "
      [headingType]="HeadingType.H3"
      [size]="TextSize.MID"
      [flMarginBottom]="Margin.XXSMALL"
    >
      <ng-content select="fl-section-article-heading"></ng-content>
    </fl-heading>
    <fl-text
      [color]="
        color === SectionArticleColor.DARK ? FontColor.DARK : FontColor.LIGHT
      "
      [size]="TextSize.SMALL"
    >
      <ng-content select="fl-section-article-description"></ng-content>
    </fl-text>
  `,
})
export class SectionArticleEntryComponent {
  Margin = Margin;
  FontColor = FontColor;
  TextSize = TextSize;
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  IconColor = IconColor;
  SectionArticleColor = SectionArticleColor;

  @Input() color: SectionArticleColor = SectionArticleColor.DARK;
  @Input() icon: string;
}

@Component({
  selector: 'fl-section-article',
  template: `
    <fl-container>
      <fl-grid> <ng-content></ng-content> </fl-grid>
    </fl-container>
  `,
  styleUrls: ['./section-article.component.scss'],
})
export class SectionArticleComponent {
  @HostBinding('attr.data-alignment')
  @Input()
  alignment: SectionArticleAlignment;

  @HostBinding('attr.data-size')
  @Input()
  size?: SectionArticleSize;
}
